import request from '@/utils/request'
import requestJson from "@/utils/requestJson"
import service from '@/utils/request'

export function smokePriceGetList(data) {
  return request({
    url: '/admin/Smoke_price_management/get_list',
    method: 'get',
    params: { ...data, comp_id: data.comp_id || 100 }
  })
}

export function smokePriceGetOne(data) {
  return request({
    url: '/admin/Smoke_price_management/getOne',
    method: 'get',
    params: { ...data, comp_id: data.comp_id || 100 }
  })
}

export function smokePriceAdd(data) {
  return requestJson({
    url: '/admin/Smoke_price_management/add',
    method: 'post', 
    data: { ...data, comp_id: data.comp_id || 100 }
  })
}

export function smokePriceUp(data) {
  return requestJson({
    url: '/admin/Smoke_price_management/up',
    method: 'post',
    data: { ...data, comp_id: data.comp_id || 100 }
  })
}

export function smokePriceDel(data) {
  return request({
    url: '/admin/Smoke_price_management/del',
    method: 'get',
    params: { ...data, comp_id: data.comp_id || 100 }
  })
}

export function smokePriceBatchUpdate(data) {
  return requestJson({
    url: '/admin/Smoke_price_management/batch_update',
    method: 'post',
    data: { ...data, comp_id: data.comp_id || 100 }
  })
}

export function smokePriceImportExcel(data) {
  return service({
    url: '/admin/Smoke_price_management/import_excel',
    method: 'post',
    data: data
  })
}

export function smokePriceExportExcel(data) {
  return request({
    url: '/admin/Smoke_price_management/export_excel',
    method: 'get',
    params: { ...data, comp_id: data.comp_id || 100 }
  })
}

export function smokePriceGetTemplate(data) {
  return request({
    url: '/admin/Smoke_price_management/get_template',
    method: 'get',
    params: { ...data, comp_id: data.comp_id || 100 }
  })
}



// WEBPACK FOOTER //
// ./src/api/smoke.js